import React, { PropsWithChildren, ForwardRefRenderFunction } from 'react';
import IconSpinner from '@/svgs/loading.svg?react';
import ButtonSimple from '@/Components/ButtonSimple';

interface ButtonProps {
  pending?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const Button: ForwardRefRenderFunction<
  HTMLButtonElement,
  PropsWithChildren<ButtonProps>
> = ({ children, pending = false, ...props }, ref) => {
  return (
    <ButtonSimple ref={ref} type="button" className="p-1" {...props}>
      {pending ? <IconSpinner className="h-4 w-4" /> : children}
    </ButtonSimple>
  );
};
export default React.forwardRef(Button);
